import { ReactNode } from 'react';

export interface BodyTextProps {
    children : ReactNode;
    className?: string;
}

const BodyText = ({
    children,
    className = '', // default props
} : BodyTextProps) => <p className={`body-text ${className}`}>{children}</p>;

// BodyText.defaultProps = {
//     className: '',
// };
export default BodyText;
